export default "__VITE_ASSET__LNr0AAc0__"